import {Component} from 'react'
import Cookie from 'js-cookie'
import Loader from 'react-loader-spinner'

import Header from '../Header'
import Sidebar from '../Sidebar'
import NonHomePageVideosContainer from '../NonHomePageVideosContainer'

import {GamingBgContainer} from './styledComponents'
import {
  LoaderContainer,
  RetryBtn,
  FailureContent,
  FailureHeading,
  NoVideoImg,
  NonVideoContainer,
} from '../Home/styledComponents'
import {NonHeaderContainer} from '../TrendingRoute/styledComponents'
import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'

const apiStatus = {
  initial: 'INITIAL',
  inProgress: 'IN_PROGRESS',
  success: 'SUCCESSFUL',
  failed: 'FAILURE',
}

class GamingRoute extends Component {
  state = {
    videosList: [],
    fetchStatus: apiStatus.initial,
  }

  componentDidMount() {
    this.setState({fetchStatus: apiStatus.inProgress})
    this.fetchGamingVideos()
  }

  fetchGamingVideos = async () => {
    const token = Cookie.get('jwt_token')
    const options = {
      headers: {Authorization: `Bearer ${token}`},
    }
    const response = await fetch('https://apis.ccbp.in/videos/gaming', options)
    if (response.ok) {
      const data = await response.json()
      const updatedList = data.videos.map(eachItem => ({
        id: eachItem.id,
        title: eachItem.title,
        thumbnailUrl: eachItem.thumbnail_url,
        viewCount: eachItem.view_count,
      }))
      this.setState({fetchStatus: apiStatus.success, videosList: updatedList})
    } else {
      this.setState({fetchStatus: apiStatus.failed})
    }
  }

  renderFailedView = darkMode => {
    const imgUrl = darkMode
      ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-dark-theme-img.png'
      : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png'
    return (
      <NonVideoContainer>
        <NoVideoImg src={imgUrl} alt="failure view" />
        <FailureHeading darkMode={darkMode}>
          Oops! Something Went Wrong
        </FailureHeading>
        <FailureContent darkMode={darkMode}>
          We are having some trouble to complete your request. Please try again.
        </FailureContent>
        <RetryBtn type="button" onClick={this.fetchGamingVideos}>
          Retry
        </RetryBtn>
      </NonVideoContainer>
    )
  }

  renderLoadingView = darkMode => (
    <LoaderContainer data-testid="loader">
      <Loader
        type="ThreeDots"
        color={darkMode ? '#3b82f6' : '#000000'}
        height="50"
        width="50"
      />
    </LoaderContainer>
  )

  renderRespectiveContainer = darkMode => {
    const {fetchStatus, videosList} = this.state
    switch (fetchStatus) {
      case apiStatus.failed:
        return this.renderFailedView(darkMode)
      case apiStatus.inProgress:
        return this.renderLoadingView(darkMode)
      case apiStatus.success:
        return (
          <NonHomePageVideosContainer
            category="Gaming"
            videosList={videosList}
          />
        )
      default:
        return null
    }
  }

  render() {
    return (
      <NxtWatchContext.Consumer>
        {value => {
          const {darkMode} = value
          return (
            <GamingBgContainer>
              <Header />
              <NonHeaderContainer data-testid="gaming" darkMode={darkMode}>
                <Sidebar />
                {this.renderRespectiveContainer(darkMode)}
              </NonHeaderContainer>
            </GamingBgContainer>
          )
        }}
      </NxtWatchContext.Consumer>
    )
  }
}
export default GamingRoute
